import inputComponents from './inputComponents'
import selectComponents from './selectComponents'
import buttonComponents from './buttonComponents'
import layoutComponents from './layoutComponents'

export default [
	{
		label: '输入型组件',
		list: inputComponents
	},
	{
		label: '选择型组件',
		list: selectComponents
	},
	{
		label: '按钮型组件',
		list: buttonComponents
	},
	{
		label: '布局型组件',
		list: layoutComponents
	}
]